import React, { useEffect, useState } from "react";
import api, { getErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function HeroPanel() {
  const [form, setForm] = useState({
    hero_eyebrow_en: "", hero_eyebrow_zh: "",
    hero_title_a_en: "", hero_title_a_zh: "",
    hero_title_b_en: "", hero_title_b_zh: "",
    hero_sub_en: "", hero_sub_zh: "",
    hero_stats: [{ n: "", label: "" }, { n: "", label: "" }, { n: "", label: "" }],
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => { (async () => {
    try {
      const { data } = await api.get("/settings");
      const stats = (data?.hero_stats && data.hero_stats.length === 3) ? data.hero_stats : [{ n: "", label: "" }, { n: "", label: "" }, { n: "", label: "" }];
      setForm({
        hero_eyebrow_en: data?.hero_eyebrow_en || "", hero_eyebrow_zh: data?.hero_eyebrow_zh || "",
        hero_title_a_en: data?.hero_title_a_en || "", hero_title_a_zh: data?.hero_title_a_zh || "",
        hero_title_b_en: data?.hero_title_b_en || "", hero_title_b_zh: data?.hero_title_b_zh || "",
        hero_sub_en: data?.hero_sub_en || "", hero_sub_zh: data?.hero_sub_zh || "",
        hero_stats: stats,
      });
    } catch { /* ignore */ }
  })(); }, []);

  async function save() {
    setSaving(true);
    try {
      const cleanStats = form.hero_stats.filter(s => s.n && s.label);
      const payload = { ...form, hero_stats: cleanStats.length ? cleanStats : null };
      await api.put("/settings", payload);
      toast.success("Home content saved");
    } catch(e) { toast.error(getErrorDetail(e)); }
    finally { setSaving(false); }
  }

  function field(key, label, multiline) {
    return (
      <div>
        <Label className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">{label}</Label>
        {multiline
          ? <Textarea rows={3} value={form[key]} onChange={(e)=>setForm({...form, [key]: e.target.value})} data-testid={`hero-${key}`} className="mt-2" />
          : <Input value={form[key]} onChange={(e)=>setForm({...form, [key]: e.target.value})} data-testid={`hero-${key}`} className="mt-2" />}
      </div>
    );
  }

  return (
    <div data-testid="admin-hero-panel" className="space-y-6 bg-white border border-[hsl(var(--border))] rounded-2xl p-6 md:p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {field("hero_eyebrow_en", "Eyebrow (English)")}
        {field("hero_eyebrow_zh", "Eyebrow (中文)")}
        {field("hero_title_a_en", "Title line 1 (English)")}
        {field("hero_title_a_zh", "Title line 1 (中文)")}
        {field("hero_title_b_en", "Title line 2 (English)")}
        {field("hero_title_b_zh", "Title line 2 (中文)")}
        {field("hero_sub_en", "Subtitle (English)", true)}
        {field("hero_sub_zh", "Subtitle (中文)", true)}
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted-foreground))] mb-3">Stats (3 cells under the title)</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {form.hero_stats.map((s, i) => (
            <div key={i} className="grid grid-cols-2 gap-2">
              <Input placeholder="e.g. 8+" value={s.n} onChange={(e)=>{ const next=[...form.hero_stats]; next[i]={...next[i], n: e.target.value}; setForm({...form, hero_stats: next}); }} data-testid={`hero-stat-n-${i}`} />
              <Input placeholder="e.g. yrs studio" value={s.label} onChange={(e)=>{ const next=[...form.hero_stats]; next[i]={...next[i], label: e.target.value}; setForm({...form, hero_stats: next}); }} data-testid={`hero-stat-label-${i}`} />
            </div>
          ))}
        </div>
      </div>
      <Button onClick={save} disabled={saving} data-testid="hero-save" className="rounded-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white">{saving ? "…" : "Save home content"}</Button>
      <p className="text-xs text-[hsl(var(--muted-foreground))]">Tip: leave any field blank to fall back to the built-in default for that language.</p>
    </div>
  );
}
